import { useEffect, useState } from 'react'
import { LogOut, User } from 'lucide-react'
import { supabase } from '../supabase'

export function UserMenu() {
  const [email, setEmail] = useState('')
  const [open, setOpen] = useState(false)
  useEffect(() => { supabase.auth.getUser().then(({data}) => setEmail(data.user?.email || 'Usuário')) }, [])
  const initial = (email || 'U').trim().charAt(0).toUpperCase()
  return <div className="fixed right-3 sm:right-4 bottom-[max(0.75rem,env(safe-area-inset-bottom))] sm:bottom-4 z-[120]">
    {open && <div className="absolute bottom-14 right-0 w-[min(16rem,calc(100vw-1.5rem))] rounded-xl border border-gray-200 dark:border-[#5A5A5E] bg-white dark:bg-[#232326] shadow-2xl p-3">
      <div className="flex items-center gap-3 pb-3 mb-3 border-b border-gray-200 dark:border-[#414142]">
        <div className="w-10 h-10 rounded-full bg-[#FCD016] text-[#18181A] grid place-items-center font-black text-lg">{initial}</div>
        <div className="min-w-0"><p className="text-xs text-gray-500 dark:text-gray-400">Logado como</p><p className="text-sm font-semibold truncate text-[#1F1F21] dark:text-white">{email}</p></div>
      </div>
      <button onClick={()=>supabase.auth.signOut()} className="w-full px-3 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white font-bold text-sm flex items-center justify-center gap-2"><LogOut size={15}/>Sair</button>
    </div>}
    <button onClick={()=>setOpen(v=>!v)} title="Conta" className="h-11 px-3 rounded-full bg-[#2D2D30] border border-[#5A5A5E] text-white shadow-lg flex items-center gap-2 hover:bg-[#414142]">
      <span className="w-7 h-7 rounded-full bg-[#FCD016] text-[#18181A] grid place-items-center font-black">{initial}</span>
      <User size={15} className="hidden sm:block"/>
    </button>
  </div>
}
